import type { Common } from 'trackolding/lib/modern';

// MBD string properties are limited to 40 characters; values longer than this are dropped.
const MAX_STRING_PROPERTY_LENGTH = 40;

export const mbdTrackingParams = (
  name: string,
  stringProperties: Record<string, string> | undefined = undefined,
) => {
  const truncatedStringProperties = stringProperties
    ? Object.fromEntries(
        Object.entries(stringProperties).map(([key, value]) => [
          key,
          value.slice(0, MAX_STRING_PROPERTY_LENGTH),
        ]),
      )
    : undefined;
  const footerComponentTrackingParams: Common = {
    component_name: name,
    ...(truncatedStringProperties ? { string_properties: truncatedStringProperties } : undefined),
  };
  return JSON.stringify(footerComponentTrackingParams);
};
